import {useMutation, UseMutationResult, useQueryClient} from '@tanstack/react-query';
import {queryKey} from './calculation-gold-querykeys';
import {AxiosHttpClient} from '../../../envisia/auth/axios-http-client';
import {environment} from '../../../../environments/environment';
import {useContext} from 'react';
import {ErpAlertContext} from '../../components/react-angular-alert/erp-react-alert-context';

export function useCalculationGoldImportUmicoreMutation(): UseMutationResult<void> {
  const alertContext = useContext(ErpAlertContext);
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () =>
      AxiosHttpClient.postNullable<void>(
        `${environment.apiv4uri}calculation/gold/import/umicore`,
        {}),
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: queryKey.list()});
      alertContext.context.add('success', 'Liste erfolgreich abgeglichen');
    },
    onError: () => {
      alertContext.context.add('danger', 'Konnte Umicore CSV nicht herunterladen');
    },
  });
}
